import ProjectsCarousel from './ProjectsCarousel';

export default ProjectsCarousel;